import { render } from "./PremiumFeatureModal.vue?vue&type=template&id=63694798"
import script from "./PremiumFeatureModal.vue?vue&type=script&lang=js"
export * from "./PremiumFeatureModal.vue?vue&type=script&lang=js"

import "./PremiumFeatureModal.vue?vue&type=style&index=0&id=63694798&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__